export default class Track {
  constructor(track) {
    this.current = track
  }

  hasNext() {
    return false
  }

  hasPrevious() {
    return false
  }
}
